module.exports = __webpack_public_path__ + "img/01_ctesup.151bf3ad.png";